interface XIconProps {
  color?: string;
  width?: number;
  height?: number;
  className?: string;
}

/** @deprecated Use icons from icons-v2-generated instead. */
export function XIcon({ width = 16, height = 16, className = '', color = '#FAFAFA' }: XIconProps) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M13.9164 8C13.9164 4.73242 11.2679 2.08318 8.00037 2.08301C4.73268 2.08301 2.08337 4.73232 2.08337 8C2.08355 11.2675 4.73279 13.916 8.00037 13.916C11.2678 13.9158 13.9162 11.2674 13.9164 8ZM15.4164 8C15.4162 12.0959 12.0962 15.4158 8.00037 15.416C3.90436 15.416 0.58355 12.096 0.583374 8C0.583374 3.90389 3.90425 0.583008 8.00037 0.583008C12.0963 0.583184 15.4164 3.904 15.4164 8Z"
        fill={color}
      />
      <path
        d="M9.80343 5.13607C10.0963 4.84334 10.5711 4.84323 10.864 5.13607C11.1567 5.42892 11.1567 5.90376 10.864 6.19661L9.06027 7.99935L10.864 9.80306L10.9148 9.8597C11.1552 10.1543 11.1386 10.589 10.864 10.8636C10.5893 11.1382 10.1547 11.1548 9.86007 10.9144L9.80343 10.8636L7.99972 9.05989L6.19699 10.8636C5.90414 11.1563 5.42929 11.1563 5.13644 10.8636C4.8436 10.5708 4.84371 10.096 5.13644 9.80306L6.93917 7.99935L5.13644 6.19661L5.08468 6.13997C4.84437 5.84539 4.86184 5.41067 5.13644 5.13607C5.41104 4.86146 5.84577 4.844 6.14035 5.08431L6.19699 5.13607L7.99972 6.9388L9.80343 5.13607Z"
        fill={color}
      />
    </svg>
  );
}
